'use client';
function getEnv() {
    try {
        return process.env.NODE_ENV || 'production';
    } catch (t) {
        return 'production';
    }
}
function isTestEnv() {
    return 'test' === process.env.NODE_ENV;
}
function isProduction() {
    return 'production' === process.env.NODE_ENV;
}
function isNotProduction() {
    return 'production' !== process.env.NODE_ENV;
}
function isNotTestOrProduction() {
    let t = process.env.NODE_ENV;
    return 'production' !== t && 'test' !== t;
}

export { getEnv, isNotProduction, isNotTestOrProduction, isProduction, isTestEnv };
